import { ContextKey, Key } from '../storage';

export const getKeys = () => Object.values(Key);

export const isKey = (key: ContextKey): key is Key =>
    getKeys().includes(key as Key);
